import { createFileRoute } from "@tanstack/react-router";
import { SupplierQuoteTab } from "../../../../pages/suppliers-page/supplier-quote-tab";

export const Route = createFileRoute("/_auth/_frame/suppliers/$supplierId/")({
  component: SupplierQuoteTab,
});
